<template>
    <div class="row justify-content-center">
        <div class="col-12 col-lg-10">
            <div class="card shadow-light-lg">
                <div class="card-header bg-dark p-0">
                    <ul class="nav nav-tabs nav-tabs-code" role="tablist">
                        <li class="nav-item" v-for="(lang, index) in codeTabs" :key="lang.id">
                            <button
                                class="nav-link"
                                :class="{ active: index === 0 }"
                                :id="`${lang.id}-tab`"
                                data-bs-toggle="tab"
                                :data-bs-target="`#${lang.id}`"
                                type="button"
                                role="tab"
                            >
                                {{ lang.name }}
                            </button>
                        </li>
                    </ul>
                </div>
                <div class="card-body bg-dark p-0">
                    <div class="tab-content">
                        <div
                            v-for="(lang, index) in codeTabs"
                            :key="lang.id + '-' + apiKey"
                            class="tab-pane fade"
                            :class="{ 'show active': index === 0 }"
                            :id="lang.id"
                            role="tabpanel"
                        >
                            <div class="position-relative">
                                <button
                                    class="btn-copy-code"
                                    @click="copyCode(lang.id)"
                                    :title="copiedLang === lang.id ? 'Copied' : 'Copy'"
                                >
                                    <svg v-if="copiedLang === lang.id" xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"/>
                                    </svg>
                                    <svg v-else xmlns="http://www.w3.org/2000/svg" width="14" height="14" fill="currentColor" viewBox="0 0 16 16">
                                        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1v-1z"/>
                                        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5h3zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0h-3z"/>
                                    </svg>
                                </button>
                                <pre class="mb-0 p-4"><code :class="lang.highlight">{{ lang.code }}</code></pre>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { EventBus } from '../bus'
import hljs from 'highlight.js/lib/core'
import python from 'highlight.js/lib/languages/python'
import javascript from 'highlight.js/lib/languages/javascript'
import typescript from 'highlight.js/lib/languages/typescript'
import php from 'highlight.js/lib/languages/php'
import go from 'highlight.js/lib/languages/go'
import java from 'highlight.js/lib/languages/java'
import csharp from 'highlight.js/lib/languages/csharp'
import ruby from 'highlight.js/lib/languages/ruby'
import rust from 'highlight.js/lib/languages/rust'
import bash from 'highlight.js/lib/languages/bash'

hljs.registerLanguage('python', python)
hljs.registerLanguage('javascript', javascript)
hljs.registerLanguage('typescript', typescript)
hljs.registerLanguage('php', php)
hljs.registerLanguage('go', go)
hljs.registerLanguage('java', java)
hljs.registerLanguage('csharp', csharp)
hljs.registerLanguage('ruby', ruby)
hljs.registerLanguage('rust', rust)
hljs.registerLanguage('bash', bash)

export default {
    name: 'CodeExamples',
    data() {
        return {
            copiedLang: null,
            userAccessKey: null
        }
    },
    computed: {
        apiKey() {
            return this.userAccessKey || 'your_access_key'
        },
        codeTabs() {
            const key = this.apiKey
            return [
                {
                    id: 'python',
                    name: 'Python',
                    highlight: 'language-python',
                    code: `import requests

API_KEY = "${key}"
BASE_URL = "https://api.datalikers.com"

# Get Instagram user by username
response = requests.get(
    f"{BASE_URL}/v1/user/by/username",
    params={"username": "instagram"},
    headers={"x-access-key": API_KEY}
)
user = response.json()
print(f"Followers: {user['follower_count']}")`
                },
                {
                    id: 'javascript',
                    name: 'JavaScript',
                    highlight: 'language-javascript',
                    code: `const API_KEY = "${key}";
const BASE_URL = "https://api.datalikers.com";

// Get Instagram user by username
const response = await fetch(
    \`\${BASE_URL}/v1/user/by/username?username=instagram\`,
    { headers: { "x-access-key": API_KEY } }
);
const user = await response.json();
console.log(\`Followers: \${user.follower_count}\`);`
                },
                {
                    id: 'php',
                    name: 'PHP',
                    highlight: 'language-php',
                    code: `<?php
$apiKey = "${key}";
$baseUrl = "https://api.datalikers.com";

// Get Instagram user by username
$ch = curl_init();
curl_setopt($ch, CURLOPT_URL, "$baseUrl/v1/user/by/username?username=instagram");
curl_setopt($ch, CURLOPT_HTTPHEADER, ["x-access-key: $apiKey"]);
curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);
$response = curl_exec($ch);
$user = json_decode($response, true);
echo "Followers: " . $user['follower_count'];`
                },
                {
                    id: 'go',
                    name: 'Go',
                    highlight: 'language-go',
                    code: `package main

import (
    "encoding/json"
    "fmt"
    "net/http"
)

func main() {
    apiKey := "${key}"
    baseURL := "https://api.datalikers.com"

    req, _ := http.NewRequest("GET", baseURL+"/v1/user/by/username?username=instagram", nil)
    req.Header.Set("x-access-key", apiKey)

    client := &http.Client{}
    resp, _ := client.Do(req)
    defer resp.Body.Close()

    var user map[string]interface{}
    json.NewDecoder(resp.Body).Decode(&user)
    fmt.Println("Followers:", user["follower_count"])
}`
                },
                {
                    id: 'java',
                    name: 'Java',
                    highlight: 'language-java',
                    code: `import java.net.http.*;
import java.net.URI;

public class DataLikersExample {
    public static void main(String[] args) throws Exception {
        String apiKey = "${key}";
        String baseUrl = "https://api.datalikers.com";

        HttpClient client = HttpClient.newHttpClient();
        HttpRequest request = HttpRequest.newBuilder()
            .uri(URI.create(baseUrl + "/v1/user/by/username?username=instagram"))
            .header("x-access-key", apiKey)
            .build();

        HttpResponse<String> response = client.send(
            request, HttpResponse.BodyHandlers.ofString()
        );
        System.out.println(response.body());
    }
}`
                },
                {
                    id: 'curl',
                    name: 'cURL',
                    highlight: 'language-bash',
                    code: `curl -X GET "https://api.datalikers.com/v1/user/by/username?username=instagram" \\
  -H "x-access-key: ${key}"`
                },
                {
                    id: 'csharp',
                    name: 'C#',
                    highlight: 'language-csharp',
                    code: `using System.Net.Http;

var apiKey = "${key}";
var baseUrl = "https://api.datalikers.com";

using var client = new HttpClient();
client.DefaultRequestHeaders.Add("x-access-key", apiKey);

var response = await client.GetAsync(
    $"{baseUrl}/v1/user/by/username?username=instagram"
);
var user = await response.Content.ReadAsStringAsync();
Console.WriteLine(user);`
                },
                {
                    id: 'ruby',
                    name: 'Ruby',
                    highlight: 'language-ruby',
                    code: `require 'net/http'
require 'json'

api_key = "${key}"
base_url = "https://api.datalikers.com"

uri = URI("#{base_url}/v1/user/by/username?username=instagram")
request = Net::HTTP::Get.new(uri)
request["x-access-key"] = api_key

response = Net::HTTP.start(uri.hostname, uri.port, use_ssl: true) do |http|
  http.request(request)
end

user = JSON.parse(response.body)
puts "Followers: #{user['follower_count']}"`
                },
                {
                    id: 'rust',
                    name: 'Rust',
                    highlight: 'language-rust',
                    code: `use reqwest::header;

#[tokio::main]
async fn main() -> Result<(), Box<dyn std::error::Error>> {
    let api_key = "${key}";
    let base_url = "https://api.datalikers.com";

    let client = reqwest::Client::new();
    let response = client
        .get(format!("{}/v1/user/by/username?username=instagram", base_url))
        .header("x-access-key", api_key)
        .send()
        .await?
        .json::<serde_json::Value>()
        .await?;

    println!("Followers: {}", response["follower_count"]);
    Ok(())
}`
                },
                {
                    id: 'typescript',
                    name: 'TypeScript',
                    highlight: 'language-typescript',
                    code: `const API_KEY: string = "${key}";
const BASE_URL: string = "https://api.datalikers.com";

interface User {
    username: string;
    follower_count: number;
}

const response = await fetch(
    \`\${BASE_URL}/v1/user/by/username?username=instagram\`,
    { headers: { "x-access-key": API_KEY } }
);
const user: User = await response.json();
console.log(\`Followers: \${user.follower_count}\`);`
                }
            ]
        }
    },
    methods: {
        fetchUserToken() {
            this.$services.Token().get().then(resp => {
                if (resp.body.data && resp.body.data.length > 0) {
                    // Prefer non-MCP token for code examples
                    const nonMcpToken = resp.body.data.find(t =>
                        !t.name || !t.name.toLowerCase().includes('mcp')
                    )
                    this.userAccessKey = nonMcpToken
                        ? nonMcpToken.access_key
                        : resp.body.data[0].access_key
                }
            }).catch(err => {
                console.error('Failed to fetch token:', err)
            })
        },
        onContextLoaded(context) {
            if (context.id) {
                this.fetchUserToken()
            }
        },
        copyCode(langId) {
            const lang = this.codeTabs.find(l => l.id === langId)
            if (!lang) return

            const onSuccess = () => {
                this.copiedLang = langId
                setTimeout(() => {
                    this.copiedLang = null
                }, 2000)
            }

            if (navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(lang.code).then(onSuccess)
            } else {
                const textarea = document.createElement('textarea')
                textarea.value = lang.code
                textarea.style.position = 'fixed'
                textarea.style.opacity = '0'
                document.body.appendChild(textarea)
                textarea.select()
                try {
                    document.execCommand('copy')
                    onSuccess()
                } catch (e) {
                    console.error('Copy failed', e)
                }
                document.body.removeChild(textarea)
            }
        }
    },
    created() {
        EventBus.on('context:loaded', this.onContextLoaded)
        if (this.$state.context.id) {
            this.fetchUserToken()
        }
    },
    mounted() {
        this.$nextTick(() => {
            document.querySelectorAll('pre code').forEach((el) => {
                if (!el.dataset.highlighted) {
                    hljs.highlightElement(el)
                }
            })
        })
    },
    updated() {
        this.$nextTick(() => {
            document.querySelectorAll('pre code').forEach((el) => {
                if (!el.dataset.highlighted) {
                    hljs.highlightElement(el)
                }
            })
        })
    },
    beforeUnmount() {
        EventBus.off('context:loaded', this.onContextLoaded)
    }
}
</script>

<style scoped>
.nav-tabs-code {
    border-bottom: none;
}
.nav-tabs-code .nav-link {
    color: #adb5bd;
    border: none;
    border-radius: 0;
    padding: 0.6rem 0.8rem;
    font-size: 0.875rem;
    background: transparent;
}
.nav-tabs-code .nav-link:hover {
    color: #fff;
    background: rgba(255,255,255,0.1);
}
.nav-tabs-code .nav-link.active {
    color: #fff;
    background: #2d3748;
    border-bottom: 2px solid #335eea;
}
pre {
    background: #1a202c;
    color: #e2e8f0;
    border-radius: 0;
    overflow-x: auto;
}
pre code {
    font-size: 0.875rem;
    line-height: 1.6;
}
.btn-copy-code {
    position: absolute;
    top: 8px;
    right: 8px;
    background: rgba(255, 255, 255, 0.08);
    border: none;
    color: #8b949e;
    padding: 5px 7px;
    border-radius: 4px;
    cursor: pointer;
    transition: all 0.15s;
    line-height: 1;
    z-index: 10;
}
.btn-copy-code:hover {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
}
</style>
